var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessageicon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 58 58",
    style: {
      enableBackground: "new 0 0 58 58"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#6FBD43;}\n\t.st1{fill:#303A49;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.2,10.5H13.8C6.2,10.5,0,16.7,0,24.3v11.3c0,7.6,6.4,13.9,14,13.9l0,0v7.4c0,0.5,0.4,0.8,0.7,0.4l1.5-1.5 c4.1-4.1,9.7-6.3,15.5-6.3h1.4c7.6,0,13.8-6.3,13.8-13.9V24.3C47,16.7,40.8,10.5,33.2,10.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.2,0.5H24.8c-6.4,0-11.7,4.3-13.3,10.2c0.7-0.1,1.5-0.2,2.3-0.2h19.4c7.6,0,13.8,6.2,13.8,13.8v11.3 c0,1.3-0.2,2.5-0.5,3.6C53,38.1,58,32.4,58,25.6V14.3C58,6.7,51.8,0.5,44.2,0.5z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 12,
    cy: 30.5,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 24,
    cy: 30.5,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 36,
    cy: 30.5,
    r: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageicon);
export default __webpack_public_path__ + "static/media/messageicon.0fa8a49f1d36633f59cba35eaf3b943d.svg";
export { ForwardRef as ReactComponent };